import useTenant from '@/hooks/useTenant'
import { graphql } from '@/generated/gql'
import { useQuery } from '@apollo/client'
import { StaticImageData } from 'next/image'
import { allOccasions } from './occasions'

export const ServiceTimeIds = ['foodServiceTime', 'staffServiceTime'] as const
export const TextIds = ['eventTypeOtherSimple', 'eventType', 'eventTypeOther'] as const
export const DropdownIds = ['eventType', 'eventTypeOfficeCelebration', 'eventTypeCultural'] as const

/**
 * Event details questions to apply to the "Event Details" page based on the tenant
 */
export type EventDetailsType = {
  id: string
  label?: string
  inputLabel?: string
  placeholder?: string
  type: 'radio' | 'checkbox' | 'image-cards' | 'dropdown' | 'text' | 'serviceTime'
  needs: { id: string; value: string }[]
  prefill: boolean
  options?: { title?: string; label?: string; value: string; image?: StaticImageData }[]
}
export type ServiceTimesType = EventDetailsType & { id: (typeof ServiceTimeIds)[number] }
export type TextType = EventDetailsType & { id: (typeof TextIds)[number] }
export type DropdownType = EventDetailsType & { id: (typeof DropdownIds)[number] }

export type OccasionFieldsAndEventDetails = {
  skip: boolean
  fields: EventDetailsType[]
  eventDetails: EventDetailsType[]
}

export type OccasionFields = {
  id: string
  label: string
  fallbackLabel?: string
  image: string
  active: null | { from: { day: number; month: number }; to: { day: number; month: number } }
} & OccasionFieldsAndEventDetails

const EmmaOccasionsForTenant = graphql(/* GraphQL */ `
  query EmmaOccasionsForTenant($tenantId: String!) {
    emmaOccasions(tenantId: $tenantId) {
      id
      name
      description
      activeFrom {
        day
        month
      }
      activeTo {
        day
        month
      }
      imageUrl
      isActive
      position
      code
    }
  }
`)

export const useTenantOccasions = () => {
  const tenant = useTenant()
  const { data, loading, error } = useQuery(EmmaOccasionsForTenant, {
    variables: {
      tenantId: tenant.id,
    },
  })

  if (error) throw new Error(`Failed to fetch occasions: ${error.message}`)
  const emmaOccasions = data?.emmaOccasions?.filter((occasion) => occasion.isActive) || []
  const tenantOccasions = loading ? [] : allOccasions(tenant.id, emmaOccasions)
  return {
    loading,
    occasions: tenantOccasions,
  }
}
